import { render, staticRenderFns } from "./EmployeeDocumentsLayout.vue?vue&type=template&id=08c1c356&scoped=true"
import script from "./EmployeeDocumentsLayout.vue?vue&type=script&lang=ts"
export * from "./EmployeeDocumentsLayout.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeDocumentsLayout.vue?vue&type=style&index=0&id=08c1c356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c1c356",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
